module.exports = `${require.publicPath}NotoSansSC-Bold.eed2367d.ttf`;